export default __webpack_public_path__ + "static/media/findingPatti.2d208bc5.wav";